import React from "react";

const EventCard = ({ event }: any) => {
  return (
    <div className="inline-block p-4">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={
          "https://secure.webtic.it/angwt/webtic.aspx?pu=aHR0cHM6Ly93d3cud2VidGljLml0LyMvc2hvcHBpbmc/YWN0aW9uPWxvYWRMb2NhbCZsb2NhbElkPTU0MDk=&lng=it&lid=" +
          event.hostId +
          "&tpl=blue&lvs=bnVsbA==&kid=33#/event/it/33/" +
          event.hostId +
          "/" +
          event.eventId
        }
      >
        <img
          alt=""
          src={"https://secure.webtic.it/api/" + event.picture}
          className="inline-block rounded-lg my-auto"
        />
      </a>
    </div>
  );
};

export default EventCard;
